import * as i from "react";
import { jsx as f, Fragment as w } from "react/jsx-runtime";
import * as E from "react-dom";
function S(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function P(...e) {
  return (t) => {
    let n = !1;
    const s = e.map((r) => {
      const o = S(r, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let r = 0; r < s.length; r++) {
          const o = s[r];
          typeof o == "function" ? o() : S(e[r], null);
        }
      };
  };
}
function D(...e) {
  return i.useCallback(P(...e), e);
}
function M(e, t) {
  const n = i.createContext(t), s = (o) => {
    const { children: c, ...u } = o, l = i.useMemo(() => u, Object.values(u));
    return /* @__PURE__ */ f(n.Provider, { value: l, children: c });
  };
  s.displayName = e + "Provider";
  function r(o) {
    const c = i.useContext(n);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [s, r];
}
function W(e, t = []) {
  let n = [];
  function s(o, c) {
    const u = i.createContext(c), l = n.length;
    n = [...n, c];
    const m = (p) => {
      var y;
      const { scope: a, children: h, ...d } = p, v = ((y = a == null ? void 0 : a[e]) == null ? void 0 : y[l]) || u, b = i.useMemo(() => d, Object.values(d));
      return /* @__PURE__ */ f(v.Provider, { value: b, children: h });
    };
    m.displayName = o + "Provider";
    function x(p, a) {
      var v;
      const h = ((v = a == null ? void 0 : a[e]) == null ? void 0 : v[l]) || u, d = i.useContext(h);
      if (d) return d;
      if (c !== void 0) return c;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return [m, x];
  }
  const r = () => {
    const o = n.map((c) => i.createContext(c));
    return function(u) {
      const l = (u == null ? void 0 : u[e]) || o;
      return i.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: l } }),
        [u, l]
      );
    };
  };
  return r.scopeName = e, [s, R(r, ...t)];
}
function R(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const s = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(o) {
      const c = s.reduce((u, { useScope: l, scopeName: m }) => {
        const p = l(o)[`__scope${m}`];
        return { ...u, ...p };
      }, {});
      return i.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var g = i.forwardRef((e, t) => {
  const { children: n, ...s } = e, r = i.Children.toArray(n), o = r.find(O);
  if (o) {
    const c = o.props.children, u = r.map((l) => l === o ? i.Children.count(c) > 1 ? i.Children.only(null) : i.isValidElement(c) ? c.props.children : null : l);
    return /* @__PURE__ */ f(C, { ...s, ref: t, children: i.isValidElement(c) ? i.cloneElement(c, void 0, u) : null });
  }
  return /* @__PURE__ */ f(C, { ...s, ref: t, children: n });
});
g.displayName = "Slot";
var C = i.forwardRef((e, t) => {
  const { children: n, ...s } = e;
  if (i.isValidElement(n)) {
    const r = j(n), o = $(s, n.props);
    return n.type !== i.Fragment && (o.ref = t ? P(t, r) : r), i.cloneElement(n, o);
  }
  return i.Children.count(n) > 1 ? i.Children.only(null) : null;
});
C.displayName = "SlotClone";
var N = ({ children: e }) => /* @__PURE__ */ f(w, { children: e });
function O(e) {
  return i.isValidElement(e) && e.type === N;
}
function $(e, t) {
  const n = { ...t };
  for (const s in t) {
    const r = e[s], o = t[s];
    /^on[A-Z]/.test(s) ? r && o ? n[s] = (...u) => {
      o(...u), r(...u);
    } : r && (n[s] = r) : s === "style" ? n[s] = { ...r, ...o } : s === "className" && (n[s] = [r, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function j(e) {
  var s, r;
  let t = (s = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var V = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], A = V.reduce((e, t) => {
  const n = i.forwardRef((s, r) => {
    const { asChild: o, ...c } = s, u = o ? g : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(u, { ...c, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function H(e, t) {
  e && E.flushSync(() => e.dispatchEvent(t));
}
export {
  A as P,
  g as S,
  M as a,
  N as b,
  W as c,
  H as d,
  P as e,
  D as u
};
